import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import { modalContentContainerStyle } from '@components/Modal/ModalContainer';

const LoaderModal = () => {
  return (
    <Box sx={modalContentContainerStyle}>
      <CircularProgress />
    </Box>
  );
};

export default LoaderModal;
